import script from "./CategoryDetail.vue?vue&type=script&lang=js&setup=true"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&setup=true"

import "./CategoryDetail.vue?vue&type=style&index=0&id=680c8d4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680c8d4c"]])

export default __exports__